import { Outlet, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import AlertPopup from '@/components/ui/AlertPopup'

export default function Layout() {
  const { pathname } = useLocation()
  const [popupForceOpen, setPopupForceOpen] = useState(false)

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return (
    <div className="flex flex-col min-h-screen bg-themed-primary transition-colors duration-300">
      <AlertPopup
        forceOpen={popupForceOpen}
        onClose={() => setPopupForceOpen(false)}
      />
      <Navbar onOpenPopup={() => setPopupForceOpen(true)} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
